export const Quotes: { [key: number]: boolean; } = {
  54252431: true,
  40996494: true,
  77119504: true,
  34762401: true,
  41626076: true,
  36943280: true,
  46551171: true,
  37382040: true,
  35073392: true,
  77277464: true,
  47705725: true,
  45647932: true,
  77124787: true,
  47572137: true,
  49990641: true,
  49990642: true,
  53124366: true,
  53028063: true,
  47807280: true,
  47570940: true,
  53026241: true,
  54249023: true,
  34732139: true,
  52174944: true,
  53028026: true,
  46963632: true,
  53025862: true,
  53224982: true,
  54174991: true,
  52393974: true,
  52400994: true,
  54038019: true,
  77124631: true,
  53032975: true,
  52438471: true,
  54252111: true,
  48168667: true,
  53650623: true,
  77122128: true,
  52158129: true,
  52437507: true,
  38121578: true,
  23893053: true,
  46943235: true,
  36519139: true,
  40959069: true,
  77124076: true,
  77126886: true,
  77125537: true,
  41626226: true,
  77128036: true,
  52168841: true,
  79279419: true,
  77117999: true,
  54971673: true,
  47246997: true,
  43204224: true,
  45830797: true,
  77310815: true,
  34765777: true,
  47719136: true,
  52168063: true,
  53032054: true,
  54971674: true,
  20041742: true,
  77126866: true,
  47887195: true,
  53839486: true,
  52397498: true,
  52401634: true,
  46945120: true,
  43507484: true,
  77124159: true,
  77128729: true,
  35028647: true,
  43509480: true,
  43686899: true,
  53836759: true,
  54929932: true,
  35054840: true,
  46760669: true,
  46702090: true,
  77128332: true,
  46022921: true,
  46943234: true,
  77127030: true,
  53650021: true,
  53654413: true,
  47646632: true,
  52917914: true,
  77123468: true,
  79273711: true,
  43527724: true,
  53032744: true,
  14270856: true,
  53033170: true,
  53334171: true,
  53651107: true,
  53650641: true,
  49993447: true,
  46965361: true,
  77117892: true,
  49645237: true,
  34738909: true,
  77118914: true,
  77118915: true,
  52178003: true,
  77320497: true,
  24548682: true,
  53340159: true,
  53652113: true,
  55077743: true,
  46196416: true,
  53650020: true,
  36520255: true,
  77126026: true,
  77297555: true,
  53334170: true,
  77097112: true,
  77125691: true,
  46748614: true,
  49643230: true,
  33886707: true,
  53029113: true,
  47915492: true,
  47237953: true,
  20554157: true,
  53025696: true,
  77123149: true,
  77123148: true,
  33906662: true,
  47646631: true,
  77124628: true,
  77122075: true,
  36525259: true,
  35061253: true,
  47878785: true,
  52179366: true,
  77123864: true,
  38129411: true,
  43453492: true,
  73384731: true,
  54252136: true,
  38796518: true,
  77126872: true,
  47704305: true,
  77122562: true,
  47728986: true,
  34766668: true,
  47970359: true,
  90002553: true,
  77124599: true,
  46943771: true,
  47573229: true,
  38394305: true,
  54453626: true,
  77122386: true,
  38112848: true,
  53650527: true,
  47576634: true,
  47576635: true,
  52167517: true,
  18039221: true,
  36961080: true,
  39532805: true,
  47274622: true,
  47998306: true,
  77126996: true,
  49716219: true,
  49716220: true,
  42437507: true,
  38101709: true,
  53032316: true,
  47706999: true,
  49360727: true,
  49360729: true,
  52438748: true,
  52439118: true,
  52439214: true,
  20556566: true,
  37727450: true,
  44988897: true,
  47703752: true,
  47709592: true,
  42689084: true,
  20553807: true,
  53027525: true,
  47874263: true,
  44022195: true,
  41527674: true,
  47707738: true,
  52178769: true,
  53125311: true,
  52391048: true,
  47706678: true,
  46351625: true,
  54166412: true,
  77117841: true,
  53033633: true,
  77119153: true,
  53031607: true,
  33919408: true,
  53026679: true,
  46763040: true,
  53031443: true,
  53653113: true,
  77113207: true,
  38496956: true,
  77121476: true,
  53030050: true,
  53029802: true,
  60284671: true,
  46696193: true,
  20553494: true,
  46763754: true,
  38111314: true,
  55651756: true,
  52929932: true,
  36526784: true,
  53122752: true,
  20557663: true,
  49635478: true,
  77310832: true,
  54927178: true,
  77320585: true,
  46575777: true,
  52438803: true,
  53727260: true,
  47701180: true,
  53033384: true,
  31921761: true,
  47780432: true,
  49361136: true,
  49361137: true,
  52439693: true,
  52439351: true,
  48269244: true,
  40970431: true,
  48267374: true,
  47923187: true,
  20558425: true,
  35077968: true,
  77310843: true,
  48599050: true,
  77120386: true,
  46591663: true,
  53126847: true,
  34751787: true,
  47572138: true,
  77127591: true,
  41008049: true,
  47970448: true,
  47970598: true,
  23819956: true,
  48218364: true,
  20556544: true,
  43536708: true,
  21759337: true,
  48168171: true,
  48179730: true,
  53026356: true,
  26314679: true,
  54165102: true,
  54165503: false,
  77121309: false,
  77915901: false,
  47807942: false,
  77129200: false,
  41644311: false,
  46805701: true,
  49808375: false,
  77123469: false,
  47724986: false,
  47910534: false,
  77127985: true,
  45914589: false,
  47154141: false,
  77118238: false,
  38143479: false,
  46914429: false,
  54167211: false,
  53654205: false,
  77129019: false,
  52439223: false,
  25367078: false,
  25367079: false,
  47977338: false,
  47236402: false,
  46129355: false,
  53652645: false,
  40986493: false,
  53081773: false,
  46824388: false,
  54037465: false,
  52405746: false,
  53034838: false,
  43536112: false,
  52437267: false,
  46143001: false,
  77127732: false,
  54451263: false,
  37292882: false,
  47893203: false,
  47965893: false,
  48102033: false,
  43417311: false,
  33889795: false,
  77127204: true,
  49361493: false,
  79271554: false,
  53653426: false,
  49298811: false,
  46607776: false,
  77306480: false,
  52437232: false,
  53123435: false,
  46062500: false,
  77314088: false,
  52149792: false,
  43550232: false,
  52170591: false,
  41003160: true,
  53032086: false,
  46698001: false,
  54452623: false,
  77127031: false,
  37328723: true,
  47701634: false,
  54927177: false,
  54449030: false,
  53838901: false,
  49364621: false,
  46766428: false,
}

export const AltresQuotes: { [key: string]: boolean; } = {
  '07564614Y': true,
  'Y3161071': true,
  '07072644Y': true,
  'Y0557928': true,
}